import { isBootFeatureEnabled } from "owa-metatags";

export default function isTokenFailureDetailsEnabled(): boolean {
    // This boot flight is a ripcord: enabling it turns failure detail propagation off.
    return !isBootFeatureEnabled("auth-mon-tokenFailureDetailsRipcord");
}
